import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Card, CardContent, CardHeader, Divider, Grid, Typography } from '@material-ui/core';
import HomeHeader from '../components/Layout/Header/HomeHeaderComponent';
import CommonSection from '../components/CommonSection';
import { useHistory } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import PagesHeader from '../components/Layout/Header/PagesHeaderComponent';
import WorkComponent from '../components/WorkComponent';

const CaseStudies = () => {
    const textRef = useRef();
    const history = useHistory();
    const [isTruncated, setIsTruncated] = useState(false);
    const [caseStudiesList, setCaseStudiesList] = useState([
        {
            id: 'case-study-1',
            name: 'Case Study 1',
            title: 'Managing 200+ Subjects in 38+ languages',
            description: 'How one exam board went from manual chaos to measurable calm in a month. When a client first called us, their peak month looked like a storm front on radar: 200+ subjects, 38+ languages, printers on standby, and digital teams barely keeping up with changes. The work was heroic, but the process was prone to human error. Approvals happened through sign offs that were difficult to track. Every time an item changed, someone manually updated three places and was reminded about a fourth place.',
            imageUrl: '../assets/images/carousel-11.jpg',
            redirectUrl: '/casestudy1'
        },
        {
            id: 'case-study-2',
            name: 'Case Study 2',
            title: 'Collaboration Without Borders: 400 people, 600 papers, 0 drift',
            description: 'How a single workspace made distance irrelevant. The exam season doesn’t care about geography or timezones. Authors in different cities, moderators and support specialists working nights. Picture four hundred people spread across thousands of kilometers, all trying to move six hundred papers from idea to approved in lockstep coordination.We put Item Banking in our cloud and told teams to meet there, not in their inboxes and FTP’s.Logistics and planning used to be an expensive ordeal as 400 expert moderators and authors would have to come to office for content development. Now, in the cloud, that cost was completely eliminated and transit time was saved.',
            imageUrl: '../assets/images/carousel-11.jpg',
            redirectUrl: '/casestudy2'
        },
        {
            id: 'case-study-3',
            name: 'Case Study 3',
            title: 'Many Registration Campaigns, One Platform',
            description: 'How a single institute ran 25+ end-to-end recruitment sessions for 3,000+ candidates in parallel. The brief looked simple on paper and messy in real life: a renowned academic and research institute needed to run faculty recruitment at scale—multiple postings, overlapping timelines, different eligibility rules, different documents, different fees.',
            imageUrl: '../assets/images/carousel-11.jpg',
            redirectUrl: '/casestudy3'
        }
    ])

    useEffect(() => {
        // Check if the textRef exceeds the height limit
        if (textRef.current && textRef.current.scrollHeight > textRef.current.clientHeight) {
            setIsTruncated(true);
        }
    }, []);
    return (
        <>
            {/* <HomeHeader /> */}
            <PagesHeader />
            {/* <CommonSection /> */}
            <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1rem 0 2rem 0' }}>

                <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid className='case-studies-header' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', padding: '1rem 0' }}>
                        <h1 className="section-header" style={{ fontWeight: '600', margin: '16px 0', color: "#092a49" }}>
                            Featured Case Studies
                        </h1>
                    </Grid>
                    {
                        caseStudiesList?.map((caseStudy, index) => {
                            return (
                                // <Grid item key={caseStudy?.id} style={{ width: '80%' }}>
                                <Card key={caseStudy?.id} className="case-study-card" style={{
                                    backgroundColor: 'rgb(255, 255, 255)',
                                    backgroundSize: 'cover',
                                    color: 'rgb(38, 38, 38)',
                                    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    border: '1px solid rgb(230, 235, 241)',
                                    borderRadius: '17px',
                                    boxShadow: 'inherit',
                                    width: '50%',
                                    margin: '0.5rem 2rem 2rem 2rem' // Adjust margin for spacing between cards
                                }}>
                                    <CardContent className="case-study-content d-block d-md-flex" style={{ justifyContent: 'space-between', padding: 0 }}>
                                        {/* <img
                                        className="case-study-image"
                                        src={caseStudy?.imageUrl}
                                        alt={caseStudy?.name}
                                        style={{ width: '20rem', objectFit: 'cover' }}
                                    /> */}
                                        <Grid container className={`case-study-image case-studies-style case-studies${index + 1}`}>
                                        </Grid>
                                        <Grid container style={{ padding: '1.5rem 1.5rem 1.5rem 1.5rem' }}>
                                            <Grid item className="case-study-title" onClick={() => {
                                                history.push(caseStudy?.redirectUrl);
                                            }}>
                                                <Typography variant="h6" style={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                                    {`${caseStudy?.title}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item className="case-study-description" onClick={() => history.push(caseStudy?.redirectUrl)} style={{ marginTop: '0.5rem' }}>
                                                <Typography
                                                    ref={textRef}
                                                    variant="body2"
                                                    color="textSecondary"
                                                    className={`truncate ${isTruncated ? 'truncated' : ''}`}
                                                    style={{ fontWeight: 600 }}>
                                                    {caseStudy?.description}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid item style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                            <Button
                                                variant="outlined"
                                                color="warning"
                                                style={{ marginTop: '1rem', textTransform: 'Capitalize', borderRadius: '18px' }} // Full width button
                                                onClick={() => {
                                                    // Define what happens when the button is clicked
                                                    // For example, navigating to a detailed view of the case study
                                                    history.push(caseStudy?.redirectUrl);
                                                }}
                                            >
                                                Read More
                                            </Button>
                                        </Grid> */}
                                        </Grid>
                                    </CardContent>
                                    
                                </Card>
                                // </Grid>
                            );
                        })
                    }
                </Grid>
            </Grid>
            <WorkComponent />
        </>
    )
}

export default CaseStudies;